export const RightAngleSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 17"
      fill="none"
    >
      <g clipPath="url(#clip0_23677_21245)">
        <path
          d="M3.10863 9.57896L9.44382 16.0486C9.58272 16.1917 9.74798 16.3052 9.93005 16.3827C10.1121 16.4601 10.3074 16.5 10.5047 16.5C10.7019 16.5 10.8972 16.4601 11.0793 16.3827C11.2614 16.3052 11.4266 16.1917 11.5655 16.0486C11.8438 15.7628 12 15.376 12 14.9729C12 14.5698 11.8438 14.1831 11.5655 13.8972L6.27623 8.49559L11.5655 3.09401C11.8438 2.80812 12 2.42138 12 2.01827C12 1.61515 11.8438 1.22842 11.5655 0.942527C11.4259 0.801107 11.2603 0.689223 11.0783 0.613289C10.8962 0.537354 10.7013 0.498865 10.5047 0.500026C10.308 0.498865 10.1131 0.537354 9.93105 0.613289C9.74901 0.689223 9.58344 0.801107 9.44382 0.942527L3.10863 7.41222C2.96859 7.55407 2.85743 7.72283 2.78158 7.90877C2.70572 8.09472 2.66667 8.29416 2.66667 8.49559C2.66667 8.69702 2.70572 8.89646 2.78158 9.0824C2.85743 9.26835 2.96859 9.43711 3.10863 9.57896Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_23677_21245">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="matrix(-1 0 0 -1 16 16.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
